import React, { createContext } from "react";
import firebase from "gatsby-plugin-firebase";

const FirebaseContext = createContext<firebase.app.App | null>(null);

export const withFirebase = (Component: any) => (props: any) =>
  <FirebaseContext.Consumer>{firebase => <Component {...props} firebase={firebase} />}</FirebaseContext.Consumer>;

export default FirebaseContext;
